import $ from 'jquery';
const reviewSlide = function (){
    
  $('.review-slide-wrapper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    dots: false,
    centerPadding: '100px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true
        }
      }
    ]

  });
} 

export default reviewSlide;
